import { render, staticRenderFns } from "./ArrivalDeparture.vue?vue&type=template&id=6b287280"
import script from "./ArrivalDeparture.vue?vue&type=script&lang=js"
export * from "./ArrivalDeparture.vue?vue&type=script&lang=js"
import style0 from "./ArrivalDeparture.vue?vue&type=style&index=0&id=6b287280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports